import { useState } from 'react';
import MaskedInput from 'react-text-mask';
import { Modal } from "react-bootstrap";
import { Field, Form, Formik, FormikHelpers } from 'formik';
import FormErrorContainer from '../shared/FormErrorContainer';
import { PHONE_NUMBER_MASK } from '../../../utiles/constants';
import useUtils from '../../../utiles/useUtiles';
import { CircularProgress } from '@mui/material';
import { AddUserFormValidation } from '../../../utiles/formValidation'
import Swal from 'sweetalert2';

interface Props {
    show: boolean,
    handleClose: () => void,
    selectedUser: any
}
interface FormHelpers {
    name: string,
    email: string,
    phone: string,
    status: string
    role: number
}
const ModalAddUser: React.FC<Props> = ({ show, handleClose, selectedUser }) => {

    const [loading, setLoading] = useState(false);
    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    const addUser = async (values: any, helpers: FormikHelpers<FormHelpers>) => {
        try {
            setLoading(true);
            const request = await axios.post(`${baseUrl()}/csv-tool/users/add`, { ...values });
            const { error, msg, password } = request.data;
            if (error) throw new Error(msg);
            Swal.fire({
                title: 'User Added Successfully',
                icon: 'success',
                confirmButtonText: 'Ok'
            });
            setLoading(false);
            handleClose();
            helpers.resetForm();
        } catch (error: any) {
            setLoading(false);
            toast.error(error);
        }
    };

    const editUser = async (values: any, helpers: FormikHelpers<FormHelpers>) => {
        setLoading(true);
        const request = await axios.put(`${baseUrl()}/csv-tool/users/${selectedUser.id}`, { ...values });
        const { error, msg } = request.data;
        setLoading(false);
        if (error) {
            toast.error(msg);
        } else {
            toast.success(msg);
            helpers.resetForm();
            handleClose();
        }
    };

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
            <Formik
                initialValues={{
                    name: selectedUser ? selectedUser?.name : '',
                    email: selectedUser ? selectedUser?.email : '',
                    phone: selectedUser ? selectedUser?.phone : '',
                    role: selectedUser ? selectedUser?.role : '',
                    status: selectedUser ? String(selectedUser?.status) : "1"
                }}
                validateOnChange={true}
                validateOnBlur={true}
                validationSchema={AddUserFormValidation}
                onSubmit={async (values: FormHelpers, helpers: FormikHelpers<FormHelpers>) => {
                    const params: any = {
                        ...values,
                        phone: values.phone.replace(/\D+/g, '')
                    };
                    if (values.hasOwnProperty('status')) {
                        params['status'] = +values['status'];
                    }
                    if (selectedUser) {
                        await editUser(params, helpers);
                    } else {
                        await addUser(params, helpers);
                    }
                }}>
                {({ errors, handleChange }) => (
                    <Form>
                        <Modal.Header>
                            <Modal.Title>{selectedUser ? "Edit" : "Add"} User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="cardCustom p-3">
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <label htmlFor="name">Name<strong className='text-danger'>*</strong></label>
                                                <Field name="name" className="form-control" placeholder="Name" autoComplete={"new-password"} />
                                                <FormErrorContainer nameError={errors.name} />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="email">Email<strong className='text-danger'>*</strong></label>
                                                <Field name="email" className="form-control" placeholder="Email" autoComplete={"new-password"} />
                                                <FormErrorContainer nameError={errors.email} />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="role">Role</label>
                                                <Field name="role" as="select" className="form-control">
                                                    <option value="">Select Role</option>
                                                    <option value="5">Admin</option>
                                                    <option value="6">Virtual Assistant</option>

                                                </Field>
                                                <FormErrorContainer nameError={errors.role} />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="phone">Phone</label>
                                                <Field name="phone">
                                                    {
                                                        ({ field }: any) => <MaskedInput
                                                            {...field}
                                                            type="text"
                                                            placeholder="Phone"
                                                            mask={PHONE_NUMBER_MASK}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            autoComplete={"new-password"}
                                                        />
                                                    }
                                                </Field>
                                                <FormErrorContainer nameError={errors.phone} />
                                            </div>
                                            {selectedUser && <div className="col-md-6">
                                                <label>Status</label>
                                                <div className='d-flex gap-3'>
                                                    <div className='form-check mr-4'>
                                                        <Field type="radio" name="status" value="1" className='form-check-input' id="status1" />
                                                        <label htmlFor='status1' className='form-check-label'>
                                                            Active
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <Field type="radio" name="status" value="0" className='form-check-input' id="status2" />
                                                        <label htmlFor='status2' className='form-check-label'>
                                                            Inactive
                                                        </label>
                                                    </div>
                                                    <FormErrorContainer nameError={errors.status} />
                                                </div>
                                            </div>}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center d-flex flex-nowrap gap-3">
                            <button type="button" className="btn btn-md revrex-outline-btn mt-3" onClick={handleClose}>
                                <span>Cancel</span>
                            </button>
                            <button type="submit" className="btn btn-md revrex-primary-btn mt-3" disabled={loading}>
                                <span>{loading && (<CircularProgress size={20} color={'success'} />) || 'Save'}</span>
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default ModalAddUser;